import axios from 'axios';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isRequestCancellation(error: unknown): boolean {
  try {
    // 存量 takeLatest 用 isCanceled 标记竞态取消，不能按消息文本过滤。
    return axios.isCancel(error) || (isRecord(error) && error.isCanceled === true);
  } catch {
    return false;
  }
}

/** 对齐 Axios 0.21 的默认 XHR 适配器，保留解析/序列化等客户端异常。 */
export function isTransportError(error: unknown): boolean {
  try {
    if (!isRecord(error) || error.isAxiosError !== true || error.name !== 'Error'
      || !isRecord(error.config) || typeof XMLHttpRequest === 'undefined'
      || !(error.request instanceof XMLHttpRequest)) return false;
    if (isRecord(error.response)) {
      return error.response.request === error.request
        && typeof error.response.status === 'number'
        && (error.response.status < 200 || error.response.status >= 300);
    }
    return error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT'
      || (error.message === 'Network Error' && error.request.status === 0);
  } catch {
    return false;
  }
}
